import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { createInitGameOutbound } from '../../api/outbound/pokerOutbounds';
import { MessageBoxesContainer } from '../../components/messageBoxes/messageBoxesContainer';
import { PrizeWinContainer } from '../../components/prizes/prizeWinContainer';
import { RebuyWindowContainer } from '../../components/rebuyWindowContainer';
import { ToastsContainer } from '../../components/toastsContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { DomPokerTableOverlay } from './domPokerTableOverlay';
import { FooterAlertContainer } from './footerAlertContainer';
import { FpsSampler } from './fpsSampler';
import { PokerHeaderBar } from './header/pokerHeaderBar';
import { PokerSceneMainDisplay } from './pokerSceneMainDisplay';
const CONTAINER_CSS = css `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: black;
`;
export const PokerScene = () => {
    const socketSend = useSocketSend();
    useEffect(() => {
        socketSend(createInitGameOutbound());
    }, [socketSend]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { "data-testid": 'poker-scene', css: CONTAINER_CSS, children: [_jsx(PokerHeaderBar, {}), _jsx(PokerSceneMainDisplay, {}), _jsx(DomPokerTableOverlay, {}), _jsx(FooterAlertContainer, {}), _jsx(ToastsContainer, {}), _jsx(MessageBoxesContainer, {}), _jsx(RebuyWindowContainer, {}), _jsx(PrizeWinContainer, {})] }), _jsx(FpsSampler, {})] }));
};
